import { CelestialBody } from './body'

const HOUR = 3600

export const ELIO: CelestialBody = {
  id: 'elio',
  name: 'Elio',
  mu: 1.1723328e18,
  radius: 261_600_000,
  rotationPeriod: 432_000,
  atmosphere: null,
  parentId: null,
  orbit: null,
  soiRadius: Infinity,
}

export const GAIA: CelestialBody = {
  id: 'gaia',
  name: 'Gaia',
  mu: 3.5316e12,
  radius: 600_000,
  rotationPeriod: 6 * HOUR,
  atmosphere: {
    seaLevelDensity: 1.225,
    seaLevelPressure: 101_325,
    scaleHeight: 5_600,
    ceiling: 70_000,
  },
  parentId: 'elio',
  orbit: {
    sma: 13_599_840_256,
    ecc: 0,
    inc: 0,
    raan: 0,
    argPe: 0,
    meanAnomalyAtEpoch: 3.14,
  },
  soiRadius: 84_159_286,
}

export const SELENE: CelestialBody = {
  id: 'selene',
  name: 'Selene',
  mu: 6.5138398e10,
  radius: 200_000,
  rotationPeriod: 138_984,
  atmosphere: null,
  parentId: 'gaia',
  orbit: {
    sma: 12_000_000,
    ecc: 0,
    inc: 0,
    raan: 0,
    argPe: 0,
    meanAnomalyAtEpoch: 1.7,
  },
  soiRadius: 2_429_559,
}

export const SYSTEM: Readonly<Record<string, CelestialBody>> = {
  elio: ELIO,
  gaia: GAIA,
  selene: SELENE,
}

export function bodyById(id: string): CelestialBody {
  const b = SYSTEM[id]
  if (!b) throw new Error(`Corpo celeste sconosciuto: ${id}`)
  return b
}
